import * as React from 'react';
import { Avatar } from 'antd';
import moment from 'moment';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import ChatItemBasisProps from './ChatItemBasisProps';
import ChatItemBasisState from './ChatItemBasisState';

const css = require('./ChatItemBasis.scss');

/** 聊天项基础 */
export default abstract class ChatItemBasis<P extends ChatItemBasisProps, S extends ChatItemBasisState> extends ComponentBasic<P, S> {

    constructor(props: P) {
        super(props);
    }

    /** 子类渲染 */
    protected get childElement(): JSX.Element | string {
        throw '请重写这个方';
    }

    /** 渲染自己 */
    renderSelf() {
        return (
            <div className={`${css['chat-item-basis']} clear`}>
                <div className={`${css['avatar-container-self']}`}>
                    <Avatar size="large" icon="user" />
                </div>
                <div className={`pull-right ${css['bubble-container-self']}`}>
                    <div className="text-right" >{this.nicknameStr}</div>
                    <div className={`${css['bubble']}`} >{this.childElement}</div>
                </div>
            </div>
        );
    }

    /** 渲染他人 */
    renderOther() {
        
        return (
            <div className={`${css['chat-item-basis']} clear`}>
                <div className={`${css['avatar-container-other']}`}>
                    <Avatar size="large" icon="user" />
                </div>
                <div className={`pull-left ${css['bubble-container-other']}`}>
                    <div className="text-left" >{this.nicknameStr}</div>
                    <div className={`${css['bubble']}`} >{this.childElement}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            this.props.isSelf
                ? this.renderSelf()
                : this.renderOther()
        );
    }

    /** 昵称 */
    private get nicknameStr(): string{
        const { nickname, timer } = this.props;
        return `${nickname} - ${moment(timer).format('HH:mm')}`;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/chatItem/ChatItemBasis.tsx